import { jsx as _jsx } from "react/jsx-runtime";
import clsx from "clsx";
export const Checkmark = ({ size = 16, className = "text-gray-50", }) => {
    return (_jsx("svg", { width: size, height: size, className: clsx("inline ml-1", className), fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", viewBox: "0 0 24 24", children: _jsx("polyline", { points: "20 6 9 17 4 12" }) }));
};
